import { SharingTipId } from '../../types/sharingTipId';
import { isFeatureEnabled } from 'owa-feature-flags';
import { assertNever } from 'owa-assert';

export function isSharingTipEnabled(sharingTipId: SharingTipId): boolean {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
        case SharingTipId.noPermissionToShareExternally:
        case SharingTipId.externalRecipientCSL:
        case SharingTipId.noPermissionSet:
        case SharingTipId.sharingWithLargeDL:
            return true;
        case SharingTipId.getSharingInfoFailed:
            return isFeatureEnabled('doc-attachment-sharingInfoFailureTip');
        case SharingTipId.linkWillExpire:
        case SharingTipId.linkHasExpired:
            return isFeatureEnabled('doc-attachment-contextualSharingTips');
        default:
            return assertNever(sharingTipId);
    }
}
